import {L} from "../reducer";

export function skipRepeatedCall(requestedLists, readyLists, forceMode = false) {
    return requestedLists.filter(list => {
        if (!readyLists.includes(list) || forceMode)
            return true;

        // If it has been previously called,
        switch (list) {
            case L.company_addresses:
            case L.contact_addresses:
            case L.contact_persons:
            case L.product:
            case L.product_detail:
            case L.product_detail_list:
                // Must repeat => Proceed
                return true;
            default:
                // Don't repeat => Skip
                return false;
        }
    });
}
